module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('span', [_vm._v("I was born not knowing")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("and have only had a little time to change that here and there.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("—Richard Feynman")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d4b0a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4epigraph.vue
// module id = 69
// module chunks = 0